import React from 'react'
import { styled, Switch as SwitchBase } from '@mui/material'
import BaseTypography from '../Basics/Typography'
import SkeletonBase from '../Skeletons/Skeleton'
import { PALETTE_DICTIONARY } from '../Theme/Theme.utils'

export const BaseSwitch = styled(({ color, ...props }) => <SwitchBase {...props} />)`
  &.MuiSwitch-root {
    color: ${({ theme }) => theme.palette.brand.white};
    display: flex;
    height: 20px;
    padding: 0;
    width: 36px;
  }

  &.MuiSwitch-root.MuiSwitch-sizeSmall .MuiSwitch-thumb {
    height: 14px;
    width: 14px;
  }

  &.MuiSwitch-root .MuiSwitch-switchBase,
  &.MuiSwitch-root.MuiSwitch-sizeSmall .MuiSwitch-switchBase {
    color: ${({ theme }) => theme.palette.brand.white};
    padding: 3px;
  }

  &.MuiSwitch-root .MuiSwitch-colorPrimary.Mui-checked,
  &.MuiSwitch-root .MuiSwitch-colorPrimary.Mui-disabled {
    color: ${({ theme }) => theme.palette.brand.white};
  }

  &.MuiSwitch-root .MuiSwitch-track {
    background-color: ${({ theme }) => theme.palette.gray[75]};
    border: 1px solid ${({ theme }) => theme.palette.gray[85]};
    border-radius: 12px;
    height: 90%;
    opacity: 40%;
  }

  &.MuiSwitch-root .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {
    background-color: ${({ color, theme }) =>
      color === 'blank' ? theme.palette.brand.white : theme.palette[PALETTE_DICTIONARY[color]][50]};
    border-color: ${({ color, theme }) =>
      color === 'blank' ? theme.palette.gray[85] : theme.palette[PALETTE_DICTIONARY[color]][50]};
    opacity: 1;
  }

  &.MuiSwitch-root .MuiSwitch-colorPrimary.Mui-disabled + .MuiSwitch-track {
    background-color: ${({ theme }) => theme.palette.gray[75]};
    border-color: 1px solid ${({ theme }) => theme.palette.gray[85]};
    opacity: 40%;
  }
`
export const Skeleton = styled(SkeletonBase)`
  &.MuiSkeleton-root {
    height: 100%;
    position: absolute;
  }
`
export const Typography = styled(BaseTypography)`
  &.MuiTypography-root {
    color: ${props => props.theme.palette.brand.black1};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 16px;
    line-height: initial;
  }
`
export const Root = styled(({ margin, padding, ...props }) => <div {...props} />)`
  align-items: center;
  display: flex;
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  position: relative;
`
export const Section = styled(({ loading, ...props }) => <div {...props} />)`
  padding: 8px 6px;

  &:first-of-type {
    padding: 8px 6px 8px 0;
  }

  &:last-of-type {
    padding: 8px 0 8px 6px;
  }

  visibility: ${props => (props.loading ? 'hidden' : 'visible')};
`
